import {
    DIC
} from '@/const/dic'

export const promotersApplyOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "推广员姓名",
            prop: "name",
            type: 'input',
            search:true,
            addVisdiplay: false,
            editVisdiplay: false
        }, 
        {
            label: "推广员账号",
            prop: "mobile",
            type: 'input',
            search:true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "报名时间",
            prop: "createTime",
            type: "datetime",
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "bindingType",
            type: "input",
            hide:true,
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
        // 是否已联系，YES-已联系，NO-未联系
        {
            label: "是否已联系",
            prop: "contact",
            type: "select",
            dicData: DIC.IS_CONTACT,
            search:true,
            addVisdiplay: false,
            editVisdiplay: false
        }
    ]
};